import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_GL_MASTER_DATA } from "./apiRoutes";

type mutateProps = {
  communityId: string;
  id: string;
  active: boolean;
};

const mutateUpdateGlMasterStatus = async ({
  communityId,
  id,
  active,
}: mutateProps) => {
  return await axiosAuth.patch(
    `${GET_GL_MASTER_DATA}/community/${communityId}/${id}/active?active=${active}`
  );
};

const useUpdateGlMasterStatusMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateUpdateGlMasterStatus,
    ...queryParams,
  });

export default useUpdateGlMasterStatusMutation;
